module.exports = "/images/bell-regular.svg?ff79cd840dadcc39ba60e337a59e84f0";